import { setUrlDefaults } from '@/wayfinder';

declare global {
    interface Window {
        __INITIAL_LOCALE__?: string;
    }
}

const raw =
    typeof window !== 'undefined' ? window.__INITIAL_LOCALE__ : undefined;
const locale = raw === 'en' || raw === 'sr' ? raw : 'en';

setUrlDefaults({ locale });
